import React from 'react';

//main css
import './css/app.scss';

//routing
import { Routes, Route } from 'react-router-dom';

//context
import { UserContextProvider } from './context/UserContext';
import { AlertProvider } from './context/AlertContext';

//main
import Layout from './components/Layout';

//paginas
import CatalogPage from 'pages/CatalogPage';
import LegalTextPage from 'pages/LegalTextPage';
import PrivacyPage from 'pages/PrivacyPage';
import NotFoundPage from 'pages/NotFoundPage';
import MazdaCX5Page from 'pages/MazdaCX5Page';

//fechas
import 'moment/locale/es';

const App = () => (
	<AlertProvider>
		<UserContextProvider>
			<Routes>
				<Route path="/" element={<Layout />}>
					<Route index element={<CatalogPage />} />
					<Route path="mazda-cx5" element={<MazdaCX5Page />} />
					<Route path="bases-legales" element={<LegalTextPage />} />
					<Route path="privacidad" element={<PrivacyPage />} />
					<Route path="*" element={<NotFoundPage />} />
				</Route>
			</Routes>
		</UserContextProvider>
	</AlertProvider>
);

export default App;
